<template>
  <div class="SearchResults">
    <div class="SearchResults__NavContainer">
      <SearchNav/>

      <el-radio-group v-model="mapList" size="mini" id="map-list-switch">
          <el-radio-button label="List"><i class="fas fa-list"></i></el-radio-button>
          <el-radio-button label="Map"><i class="fas fa-map-marked-alt"></i></el-radio-button>
      </el-radio-group>
    </div>

    <div class="row SearchResults__MapListingsContainer">
      <div class="SearchResults__Panel col-xs-12 col-sm-6 SearchResults__Map" v-show="this.mapList == 'Map' || this.width > 767" >
        <googleMap v-if="maps && maps.data"  />
      </div>

      <div class="SearchResults__Panel SearchResults__Listings col-xs-12 col-sm-6" v-show="this.mapList == 'List' || this.width > 767">
        <div class="row between-xs middle-xs SearchResults__ListingsHeader">
          <div class="col-xs-6 col">
            <p class="SearchResults__Heading">
                <b>{{'Search Results' | language}}</b>
                <router-link to="/needs-assessment" id="personalized-search-link">
                    {{'Need Personalized Search?' | language}}
                </router-link>
            </p>
          </div>
          <div class="col-xs-6 end-xs col">
            <el-form>
              <el-form-item>
                <el-select size="small" placeholder="Sort Results" v-model="$store.state.search.query.sort" :clearable="clearable" @change="sortChange">
                  <el-option :label="option.label | language" :value="option.value" v-for="option of $store.state.search.sortOption" :key="option.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div>
        <div class="row start-xs">
            <!-- When no properties -->
          <div class="col-xs-12 col-md-12 start-sm SearchResults__CardContainer" v-if="properties && properties.data && hasProperties === false">
              <h1>{{'There are no matching for your current search' | language}}</h1>
              <p>{{'Please broaden your search requirements' | language}}</p>
          </div>
          <!-- FOR EACH -->
          <div class="col-xs-12 col-md-12 col-lg-6 start-sm SearchResults__CardContainer"
            v-for="(property,index) of properties.data" :key="index" >
            <SearchResultListingCard :property="property" :loading="fullscreenLoading" />
          </div>
           
            <!-- END FOR EACH -->
          </div>
          <!-- init loading content loader-->
          <ListingContentLoader :fullscreenLoading="fullscreenLoading" :initLoading="initLoading"/>
          <!-- init loading content loader-->
          <div class="row center-xs">
            <div class="col-xs-12 SearchResults__PaginationContainer">
              <el-pagination v-if="properties && properties.data && properties.data.length > 0" background layout="prev, pager, next" :page-size="properties.per_page"
              @current-change="handleCurrentChange" @prev-click="prevClick" @next-click="nextClick"
              :total="properties.total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="showModal" ref="modal">
      <Property />
    </modal>
  </div>
</template>

<script>
  import SearchNav from '../_partials/SearchNav'
  import SearchResultListingCard from '../SearchResults/SearchResultListingCard'
  import googleMap from '../map/googleMap'
  import ListingContentLoader from '../Listing/ListingContentLoader'
  import Property from '../Property/Property'
  import { mapState } from 'vuex'
  import axios from 'axios';
  import Modal from "../_partials/Modal";
  import _ from 'lodash';

  export default {
    name: 'Properties',

    components: {
      SearchNav,
      googleMap,
      SearchResultListingCard,
      ListingContentLoader,
      Modal,
      Property
    },

    directives: {},
    data: function() {
      return {
        fullscreenLoading: false,
        mapLoading:false,
        loaderHeight: 500,
        loadWidth: 500,
        currentPage: 1,
        initLoading: true,
        clearable: true,
        fake: {},
        mapList: 'List',
        width: 0,
        showModal: this.$route.meta.showModal,
        pageSize:50
      }
    },
    computed: {
      ...mapState({
        properties: (state) => {
          return state.property.properties
        },
        maps:(state) => {
          return state.property.maps
        },
        hasProperties: (state) => {
          return state.property.hasProperties
        }
      }),
      isLoggedIn(){
        return this.$store.getters['user/isLoggedIn']
      }
    },
    watch: {
      '$route.params':function(from,to) {
        this.currentPage = 1;
        if (_.isEmpty(from) && _.isEmpty(to)){
          this.fetchProperties();
        }
      },
      "$route.meta"({ showModal }) {
        this.showModal = showModal;
      }
    },
    created() {
      this.fetchProperties();
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      fetchProperties() {
        const tmp = {}
        tmp.params = this.$route.name === 'Properties' ? this.$route.query :this.$store.state.search.query
        this.fullscreenLoading = true
        this.mapLoading = true
        const listPromise = this.$store.dispatch('property/properties',{...tmp.params,page:this.currentPage})
        // set map data page and page size are based on the search query, see if current zoom is smaller than 8 or without city included
        const mapPromise  = this.$store.dispatch('property/maps',{...tmp.params,page:(!tmp.params.city && !tmp.params.zoom || tmp.params.zoom < 8) ?  1 : this.currentPage ,page_size:(!tmp.params.city && !tmp.params.zoom || tmp.params.zoom < 8) ? 400 : 50})
        // const nearBy = this.$store.dispatch('property/nearby',tmp.params)
        if (tmp.params.city){
          this.$store.dispatch('property/city',tmp.params.city)
        }
        mapPromise
        .finally(() => {
            this.mapLoading =false
        })
        axios.all([listPromise])
            .finally(()=> {
                this.fullscreenLoading = false
                this.initLoading = false
            })
        },
        handleCurrentChange(e) {
            this.currentPage = e
            this.fetchProperties()
        },
        prevClick(e) {
            this.currentPage = e
        },
        nextClick(e){
            this.currentPage = e
        },
        sortChange() {
            this.$router.push({...this.$route,query:this.$store.state.search.query});
        },
        handleResize() {
            this.width = window.innerWidth;
        }
    },
        head: {
            title: function() {
                return {
                    inner: 'Properties'
                }
            },
            meta: [
                { name: 'title', content: 'Japan Home Finder Properties' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
  }
</script>

<style lang="scss">
  .bm-overlay {
    background: transparent !important;
  }

  #personalized-search-link {
        font-weight: 400;
        font-size: .85em;
        display: inline-block;
  }

  .SearchResults {
    margin: 0;
    padding: 0;
    // font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    overflow-x: hidden;
    position: relative;
    width: 100vw;
    height: 100vh;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    &__Panel {
      min-height: 100vh;

      &:first-child {
        max-height: 100%;
        padding: 115px 0 0 0;
      }

      &:nth-child(2) {
        max-height: 100%;
        overflow-y: scroll;
        padding: 120px 1.5rem 0 1rem;
      }
    }

    .el-select {
      max-width: 200px;

      input {
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__MapListingsContainer {
      overflow-y: scroll;
      height: 100%;
      max-height: 100%;
    }

    &__NavContainer {
      width: 100%;
      position: fixed;
      z-index: 100;
      background-color: white;
    }

    &__Listings {
      padding-top: 20rem;
      padding-left: 4rem;
      width: 100%;
      overflow: scroll;
    }

    &__Map {
      height: 100%;
    }

    &__ListingsHeader {
      padding: .5rem 0;
      margin: 0 0 1rem 0!important;
      border-bottom: 1px lightgray solid;

      .col {
        padding: 0;
      }

      h2 {
        margin: .5rem 0 0 0;
      }
    }

    &__Heading {
      margin: 0;

      b {
          margin-right: 1em;
      }
    }

    &__CardContainer {
        margin-bottom: 1rem;
    }

    &__PaginationContainer {
      padding: 2rem 0 3rem 0;
    }

    #map-list-switch {
      display: none;
      position: absolute;
      bottom: .5rem;
      right: 1rem;
      z-index: 100;

      .el-radio-button__inner {
        padding: 4px 15px;

        .fas {
          padding-right: 0;
        }
      }

      .el-radio-button {
        &:first-child {
          .el-radio-button__inner {
            border-radius: 3px 0 0 3px;
          }
        }

        &:last-child {
          .el-radio-button__inner {
            border-radius: 0 3px 3px 0;
          }
        }
      }

      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: transparent;
        border-color: $primary-color;
        color: $primary-color;
        box-shadow: -1px 0 0 0 $primary-color;
      }
    }
  }

  @media (max-width: 767px) {
    .SearchResults {
      &__MapListingsContainer {
        max-height: 100%;
        height: 100%;
      }

      &__MapListButtons {
        display: none;
      }

      &__Heading {
          line-height: 1;
      }

      #personalized-search-link {
          font-size: .75em;
      }

      &__Panel {
        &:first-child {
          height: 100vh;
          min-height: auto;
          padding: 90px 0 0 0;
        }

        &:nth-child(2) {
          padding-top: 0;
          padding: 90px 1.5rem 0 1.5rem;
        }
      }

      #map-list-switch {
        display: block;
      }
    }
  }
</style>

